import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor } from "./Accessor";
export var HitsAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(HitsAccessor, _Accessor);

  function HitsAccessor(options) {
    var _this;

    _classCallCheck(this, HitsAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HitsAccessor).call(this));
    _this.options = options;
    return _this;
  }

  _createClass(HitsAccessor, [{
    key: "setResults",
    value: function setResults(results) {
      _get(_getPrototypeOf(HitsAccessor.prototype), "setResults", this).call(this, results);

      this.scrollIfNeeded();
    }
  }, {
    key: "scrollIfNeeded",
    value: function scrollIfNeeded() {
      if (this.searchkit.hasHitsChanged()) {
        if (this.options.scrollTo) {
          document.querySelector(this.getScrollSelector()).scrollTop = 0;
        }
      }
    }
  }, {
    key: "getScrollSelector",
    value: function getScrollSelector() {
      return this.options.scrollTo == true ? "body" : this.options.scrollTo.toString();
    }
  }]);

  return HitsAccessor;
}(Accessor);